<template>
  <div>
    <div v-if="locationId == 0">
      <locations @set-location="setLocationData" :isValid="isStepValid" :isNew="$route.params.isNew" v-if="$route.params.isNew"></locations>
      <location-grid @set-location="setLocationData" :isValid="isStepValid" :isNew="$route.params.isNew" v-else></location-grid>

    </div>
    <div v-else>
      <volunteer-pin
        v-show="surveyStep == 0 && showVolunteer"
        :location="location"
        :surveyData="surveyData"
        @move-next="startNewSurvey"
      ></volunteer-pin>

      <participant-pin
        v-if="surveyStep == 0 && showParticipant"
        :surveyData="surveyData"
        @move-next="recordParticipant"
      ></participant-pin>
      <confirmation-pin
        v-if="surveyStep == 0 && showConfirmation"
        :surveyData="surveyData"
        @move-next="participantConfirmation"
        @cancel-survey="cancelledSurvey"
      ></confirmation-pin>
      <breadcrumb
        v-show="surveyStep > 0"
        :surveyStep="surveyStep"
        :maxStepCompleted="maxStepCompleted"
        @move-to-step="moveToStep"
      ></breadcrumb>

      <component
        :is="currentStep"
        :surveyData="surveyData"
        :isValid="isValid"
        @move-next="moveNext"
        @move-previous="movePrevious"
      ></component>
    </div>

    <!-- <survey-nav :step="surveyStep" @move-next="moveNext" @move-previous="movePrevious"></survey-nav> -->
  
    <nav class="navbar fixed-bottom survey-footer">
      Location: {{ location }}&nbsp;-&nbsp;Volunteer: {{ surveyData.VolunteerName }}
    </nav>

  </div>
</template>

<script>
import Locations from "./Location";
import LocationGrid from "./LocationGrid";
import VolunteerPin from "./VolunteerPin";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";
import Step8 from "./Step8";
import Step9 from "./Step9";
import Breadcrumb from "./Breadcrumb";
import surveyNav from "@/components/SurveyNav";
import ajax from "@/resources/myApi.js";
import ParticipantPin from "./ParticipantPin.vue";
import ConfirmationPin from "./ConfirmationPin.vue";

export default {
  name: "survey",
  data: () => ({
    isValid: false,
    volunteerPinCode: "",
    surveyStep: 0,
    maxStepCompleted: 0,
    location: "Survey Location",
    locationCode: "ABc",
    locationId: 0,
    currentStep: "",
    showVolunteer: true,
    showParticipant: false,
    showConfirmation: false,
    surveyData: {
        Id: 0,
        IsComplete: false,
        LocationId: 0,
        VolunteerId: 0,
        VolunteerName: "",
        VolunteerEmail: "",
        VolunteerPhone: "",
        VolunteerIpad: "",
        DiagnosedDiabetes: null, //boolean
        Age: null, //number
        Gender: null, //boolean
        DiagnosedGestationalDiabetes: null, //boolean
        RelativeWithDiabetes: null, //boolean
        DiagnosedCAD: null, //boolean
        DiagnosedCholesterol: null, //boolean
        DiagnosedHighBP: null, //boolean
        PhysicallyActive: null, //boolean
        Weight: null,
        HeightFeet: null,
        HeightInches: null,
        TotalRiskScore: 0,
        BMI: 0,
        Race: "",
        Ethnicity: null, //passed as 1 or 2
        CountryOfBirth: null,
        ZipCode: "",
        HaveHealthCoverage: null, //boolean
        HealthInsurancePlanName: "",
        ContactForHealthCoverage: null, //tinyint
        ContactForDiabetesPrevention: null, //boolean
        FirstAndLastName: "",
        TelephoneNumber: "",
        EmailAddress: "",
        HavePrimaryDoctor: null, //boolean
        FollowUpResults: null, //boolean
        GlucoseReading: null,
        A1CNumber: null,
        LipidsCholHdl: null,
        LipidsLdlC: null,
        LipidsChol: null,
        LipidsHdlC: null,
        LipidsTrig: null,
        Smid: 0,
        IsTestedA1C: null,
        IsTestedGlucose: null,
        IsTestedLipids: null,
        Comment: null,
        IsWpbResident: null,
        ReferenceCode: "",
        ParticipantBirthdate: "",
        ParticipantConsent: null,
        ParticipantAcknowledgement: null,
        DoSmoke: null,
        QuitSmoking: null,
        SmokingInfo: null,
        FoodRunOut: null,
        FoodDidntLast: null,
        IsFoodInsecure: null,
        HealthCoverageContact: null,
    },
    surveyResults: {
      id: null,
      locationName: null,
      locationDate: null,
      riskScore: null,
      bmi: null,
      glucose: null,
      a1c: null,
      cholHdl: null,
      chol: null,
      ldlC: null,
      hdlC: null
    }
  }),
  components: {
    LocationGrid,
    Locations,
    VolunteerPin,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
    Step8,
    Step9,
    Breadcrumb,
    surveyNav,
    ParticipantPin,
    ConfirmationPin
},
  methods: {
    setLocationData(event) {
      
      this.location = event.locName;
      this.locationId = event.locId;
      this.surveyData.locationId = this.locationId;
    },
    startNewSurvey(event) {
      //debugger;
      console.log(this.surveyData);
      this.resetSurveyData();
      console.log(this.surveyData);

      this.surveyData.Id = 0;
      this.surveyData.locationId = this.locationId;
      
      this.surveyData.VolunteerName = event.name;
      this.surveyData.VolunteerEmail = event.email;
      this.surveyData.VolunteerPhone = event.phone;
      this.surveyData.VolunteerIpad = event.ipad;
      //this.surveyData.ReferenceCode = event.referenceCode;

      console.log(`event.isValid: ${event.isValid}`);
      //console.log(`event.referenceCode: ${event.referenceCode}`);
      
      if (event.isValid) {
        this.isValid = event.isValid;
        this.showVolunteer = false;
        this.showParticipant = true;
      }
    },
    cancelledSurvey() {
      this.resetSurveyData();
      this.showVolunteer = true;
      this.showParticipant = false;
      this.showConfirmation = false;
      console.log(this.surveyData);
    },
    recordParticipant(event) {
      this.surveyData.FirstAndLastName = event.name;
      this.surveyData.EmailAddress = event.email;
      this.surveyData.TelephoneNumber = event.phone;
      this.surveyData.ParticipantBirthdate = event.birthdate;
      this.surveyData.ReferenceCode = event.referenceCode;

      if (event.isValid) {
        this.isValid = event.isValid;
         this.showParticipant = false;
         this.showConfirmation = true;
      }
    },
    participantConfirmation(event) {
      this.surveyData.ParticipantAcknowledgement = event.participantAcknowledgement;
      this.surveyData.ParticipantConsent = event.participantConsent;

      if (event.isValid) {
        this.isValid = event.isValid;
        this.showConfirmation = false;
        this.moveNext();
      }
    },
    isStepValid() {
      console.log(this.isValid);
      return this.isValid;
    },
    moveNext() {
      //if (this.isStepValid()) {
      console.log("Move Next");
      if (this.surveyStep >= 1 && this.surveyStep > this.maxStepCompleted) 
        this.maxStepCompleted += 1; //Since we are passed the first step, start tracking the max step completed

      this.surveyStep += 1;

      if (this.surveyStep >= 1 && this.surveyStep <= 9 ){
        //TODO: As we move through the steps, add/update local storage with the survey data
        this.currentStep = `Step${this.surveyStep}`;
      }

      if (this.surveyStep == 9) {
        //debugger;
        //We've reached the end of the survey
        console.log("saving...");
        this.IsComplete = true;
        var data = Object.assign({},this.surveyData);
        data.location = null;
        //this.surveyData.location = null;
        ajax
          .post("surveys/add", data)
          .then(res => {
              //console.log(this.surveyData,res.data);
              this.surveyData = res.data;              
            }) //TODO: Upon success, remove the survey data from local storage
          .catch(err => {
              console.log(err);
              alert("Error saving data");
          } );
          // this.resetSurveyData();
      } 

      if(this.surveyStep > 9){
        debugger;
        this.surveyStep = 0;
        this.showVolunteer = true;
        this.resetSurveyData(); //Clear the previous survey
        this.currentStep = "";
        this.maxStepCompleted = 0;
      }
      //}
    },
    movePrevious() {
      if (this.surveyStep > 1) {
        this.surveyStep -= 1;
        this.currentStep = `Step${this.surveyStep}`;
      }
      if (this.surveyStep === 0) {
        this.surveyStep = 1;
        this.currentStep = "";
      }
    },
    moveToStep(event) {
      console.log("Survey Move to step: " + event);
      this.surveyStep = event;
      this.currentStep = `Step${this.surveyStep}`;
    },
    resetSurveyData() {
      console.log("resetting the data");
      //NOTE: when resetting the data, we will keep the VolunteerName
      this.surveyData = {
        Id: 0,
        IsComplete: false,
        //LocationId: 0,
        VolunteerId: 0,
        DiagnosedDiabetes: null, //boolean
        Age: null, //number
        Gender: null, //boolean
        DiagnosedGestationalDiabetes: null, //boolean
        DiagnosedCAD: null, //boolean
        DiagnosedCholesterol: null, //boolean
        RelativeWithDiabetes: null, //boolean
        DiagnosedHighBP: null, //boolean
        PhysicallyActive: null, //boolean
        Weight: null,
        HeightFeet: null,
        HeightInches: null,
        TotalRiskScore: 0,
        BMI: 0,
        Race: "",
        Ethnicity: null, //passed as 1 or 2
        CountryOfBirth: null,
        ZipCode: "",
        HaveHealthCoverage: null, //boolean
        HealthInsurancePlanName: "",
        ContactForHealthCoverage: null, //tinyint
        ContactForDiabetesPrevention: null, //boolean
        FirstAndLastName: null,
        TelephoneNumber:null,
        EmailAddress: null,
        HavePrimaryDoctor: null, //boolean
        FollowUpResults: null, //boolean
        GlucoseReading: null,
        A1CNumber: null,
        LipidsCholHdl: null,
        LipidsLdlC: null,
        LipidsChol: null,
        LipidsHdlC: null,
        LipidsTrig: null,
        Smid: 0,
        IsTestedA1C: null,
        IsTestedGlucose: null,
        IsTestedLipids: null,
        Comment: null,
        IsWpbResident: null,
        ReferenceCode: null,
        ParticipantBirthDate: null,
        ParticipantConsent: null,
        ParticipantAcknowledgement: null,
        DoSmoke: null, //boolean
        QuitSmoking: null, //boolean
        SmokingInfo: null, //boolean
        FoodRunOut: null, //boolean
        FoodDidntLast: null, //boolean
        IsFoodInsecure: null, //boolean
      };
    },
    logOut() {
      this.resetSurveyData();
      this.locationId = 0;
      this.surveyStep = 0;
      this.currentStep = "";
    }
  },
  mounted() {
    this.resetSurveyData();
  }
};
</script>
.
<style scoped>
* {
  font-family: "Roboto", sans-serif;
}
.survey-footer{
  padding-bottom: 5px;
  z-index: 2000;
}
.row{
  padding-bottom: 0px;
}
</style>
